module.exports = __webpack_public_path__ + "static/media/vis8.8ece974a.jpeg";